<template>
  <div class="relative">
    <button
      type="button"
      @click="open = !open"
      :disabled="!payload"
      class="h-7 inline-flex items-center gap-1.5 px-2.5 text-xs font-semibold rounded-lg bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
    >
      <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 3v12m0 0l-4-4m4 4l4-4M4 17v2a2 2 0 002 2h12a2 2 0 002-2v-2"/>
      </svg>
      Export
    </button>

    <div v-if="open" @click="open = false" class="fixed inset-0 z-20"></div>
    <div v-if="open" class="absolute right-0 top-full mt-1.5 z-30 w-52 p-1.5 bg-white dark:bg-[#2A3037] border border-gray-100 dark:border-gray-700 rounded-xl shadow-lg">
      <button v-for="opt in OPTIONS" :key="opt.value" type="button" @click="run(opt.value)"
        class="w-full flex flex-col items-start px-2.5 py-1.5 rounded-lg text-left hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors">
        <span class="text-xs font-semibold text-gray-700 dark:text-gray-200">{{ opt.label }}</span>
        <span class="text-[11px] text-gray-400 dark:text-gray-500">{{ opt.hint }}</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { buildCsv, downloadCsv, downloadJson } from 'utils/csv.js'

// The shell only. Each dashboard passes the payload it is currently showing and
// the CSV shape for it, because the rule is that you export exactly what is on
// screen: same range, same filters, same numbers, same instant. A separate
// endpoint could drift from the screen, so there is never a second request.
const props = defineProps({
  // Basename for the downloaded file, e.g. "booking-stats".
  basename: { type: String, required: true },
  // The object written out verbatim for JSON, and the presence check that
  // disables the button while nothing has loaded.
  payload: { type: Object, default: null },
  // { meta: [[label, value]], sections: [{ name, headers, rows }] }
  csv: { type: Object, default: null },
  // Appended to the filename so a folder of exports is self-describing.
  stamp: { type: String, default: '' },
})

const open = ref(false)

const OPTIONS = [
  { value: 'csv', label: 'CSV', hint: 'Every table, one file' },
  { value: 'json', label: 'JSON', hint: 'The raw figures' },
]

function run(format) {
  open.value = false
  if (!props.payload) return

  const name = [props.basename, props.stamp].filter(Boolean).join('-')
  if (format === 'json') return downloadJson(`${name}.json`, props.payload)
  if (props.csv) downloadCsv(`${name}.csv`, buildCsv(props.csv))
}
</script>
